export default "__VITE_ASSET__CLUwSuvy__"